import { createFetcher } from '../../Common';

import { ACCESS_TOKEN_ENDPOINT, getBaseUrl } from '../../constants';

export class Refresh {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Refresh(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = ACCESS_TOKEN_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async postRefresh(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }
}

export const createRefresh = () => Refresh.getInstance();
